import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const updateAllNotificationSettingsByUser = async <
  T extends Record<string, unknown>,
>({
  query,
  domain,
  headers,
  userId,
  ...payload
}: FetchRequestArgs & { userId: string }): Promise<
  ReturnType<typeof fetchRequest>
> =>
  fetchRequest<T>({
    data: {
      ...payload, // can contain 'email', 'sms', or both properties
    },
    domain,
    endpoint: `/notifications/byUser/${userId}`,
    headers,
    method: HTTPMethod.PUT,
    query,
  });
